/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Field_Branch_EmptyInputs */

const en_case_field_branch_empty = /** @type {(inputs: Case_Field_Branch_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No branches found.`)
};

const pt_br2_case_field_branch_empty = /** @type {(inputs: Case_Field_Branch_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma filial encontrada.`)
};

/**
* | output |
* | --- |
* | "No branches found." |
*
* @param {Case_Field_Branch_EmptyInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_field_branch_empty = /** @type {((inputs?: Case_Field_Branch_EmptyInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Field_Branch_EmptyInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_field_branch_empty(inputs)
	return pt_br2_case_field_branch_empty(inputs)
});